import { CACHE_ATTRS, ZOOM_PAD } from '../helpers/DanmarksKortMap.constants.js'

const measurePaths = (element) =>
  [...element.querySelectorAll('path[data-name]')].map(path => ({ path, box: path.getBBox() }))

const unionBox = (measured) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
  measured.forEach(({ box }) => {
    if (box.x < minX) minX = box.x
    if (box.y < minY) minY = box.y
    if (box.x + box.width  > maxX) maxX = box.x + box.width
    if (box.y + box.height > maxY) maxY = box.y + box.height
  })
  return { minX, minY, maxX, maxY }
}

export function useMapCaches(wrapperRef) {
  const caches = {}

  const buildCaches = () => {
    const measured = measurePaths(wrapperRef.value)

    CACHE_ATTRS.forEach(groupAttr => {
      const grouped = new Map()
      measured.forEach(entry => {
        const key    = entry.path.dataset[groupAttr]
        const bucket = grouped.get(key)
        bucket ? bucket.push(entry) : grouped.set(key, [entry])
      })

      const group      = new Map()
      const centroid   = new Map()
      const zoomTarget = new Map()

      grouped.forEach((entries, key) => {
        group.set(key, entries.map(e => e.path))
        const { minX, minY, maxX, maxY } = unionBox(entries)
        centroid.set(key, {
          cx: (minX + maxX) / 2,
          cy: (minY + maxY) / 2
        })
        zoomTarget.set(key, {
          x: minX - ZOOM_PAD,
          y: minY - ZOOM_PAD,
          w: maxX - minX + ZOOM_PAD * 2,
          h: maxY - minY + ZOOM_PAD * 2
        })
      })

      caches[groupAttr] = { group, centroid, zoomTarget }
    })
  }

  return { caches, buildCaches }
}
